import { render } from "./MarkMeteringSystemAsInactiveForm.vue?vue&type=template&id=761e2da2&scoped=true"
import script from "./MarkMeteringSystemAsInactiveForm.vue?vue&type=script&lang=js"
export * from "./MarkMeteringSystemAsInactiveForm.vue?vue&type=script&lang=js"

import "./MarkMeteringSystemAsInactiveForm.vue?vue&type=style&index=0&id=761e2da2&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src2914688552/src/be-admin-portal/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761e2da2"]])

export default __exports__